import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEOHead = ({ title, description, path, type = 'website' }) => {
  const baseUrl = 'https://cloudxai.org';
  const fullUrl = `${baseUrl}${path || ''}`;
  const siteName = 'CloudXAI Technologies';

  return (
    <Helmet>
      <title>{title ? `${title} | ${siteName}` : siteName}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={fullUrl} />

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={title || siteName} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:site_name" content={siteName} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title || siteName} />
      <meta name="twitter:description" content={description} />
    </Helmet>
  );
};

export default SEOHead;
